import { render, staticRenderFns } from "./detailsDateManagement.vue?vue&type=template&id=07a82898"
import script from "./detailsDateManagement.vue?vue&type=script&lang=js"
export * from "./detailsDateManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports